import { Outlet } from 'react-router-dom'
import { TourProvider } from '@/tour/TourProvider'
import { BottomNav } from './BottomNav'
import { Header } from './Header'

/** Layout mobile-first: header sticky + contenido scrolleable + bottom-nav fija. */
export function AppShell() {
  return (
    <TourProvider>
      <div className="app-shell">
        <Header />
        <main className="app-scroll">
          <Outlet />
        </main>
        <BottomNav />
      </div>
    </TourProvider>
  )
}
